import React from 'react';
import { Typography, Box } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import LanguageIcon from '@mui/icons-material/Language';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import theme from './Theme';

interface PlaceContactsProps {
  contacts?: {
    phone?: string;
    website?: string;
    facebook?: string;
    instagram?: string;
  };
}

/**
 * Place contacts component displaying phone, website, and social media links.
 */
export const PlaceContacts: React.FC<PlaceContactsProps> = ({ contacts }) => {
  if (!contacts) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box display="flex" alignItems="center" gap={1}>
        <PhoneIcon sx={{ color: theme.palette.accent.main }} />
        <Typography variant="body2">{contacts.phone || 'N/A'}</Typography>
      </Box>
      <Box display="flex" alignItems="center" gap={1}>
        <LanguageIcon sx={{ color: theme.palette.accent.main }} />
        {contacts.website ? (
          <Typography variant="body2" component="a" href={contacts.website} target="_blank" rel="noopener noreferrer">
            {contacts.website}
          </Typography>
        ) : (
          <Typography variant="body2">N/A</Typography>
        )}
      </Box>
      <Box display="flex" alignItems="center" gap={1}>
        <FacebookIcon sx={{ color: theme.palette.accent.main }} />
        {contacts.facebook ? (
          <Typography variant="body2" component="a" href={contacts.facebook} target="_blank" rel="noopener noreferrer">
            Facebook
          </Typography>
        ) : (
          <Typography variant="body2">N/A</Typography>
        )}
      </Box>
      <Box display="flex" alignItems="center" gap={1}>
        <InstagramIcon sx={{ color: theme.palette.accent.main }} />
        {contacts.instagram ? (
          <Typography variant="body2" component="a" href={contacts.instagram} target="_blank" rel="noopener noreferrer">
            Instagram
          </Typography>
        ) : (
          <Typography variant="body2">N/A</Typography>
        )}
      </Box>
    </Box>
  );
};
